// Turks (tr-TR), reminders (bord): zelfde vorm als reminders.nl.ts. Wat ontbreekt valt terug op
// het Nederlands. Wordt voorgelezen in tr-TR: korte, eenvoudige woorden voor kinderen.
export const kioskRemindersTr = {
    ok: 'Tamam!',
    /** Rustig, buiten het thema Kinderen. */
    okCalm: 'Tamam',
    speak: '{names}, {title}!',
    context: '{title}, saat {time}',
    hint: 'Sonra: {title} · {time}',
    and: 've',
    dialog: 'Hatırlatma: {title}',
    okFor: 'Tamam, {name}',
    checklist: 'Çantana koy',
    checklistLeft: '{count} kaldı',
    checklistDone: 'Hepsi çantada!',
    checklistDoneCalm: 'Her şey çantada',
    checklistItem: '{label}, {name}',
    checklistItemDone: '{label} çantada',
    taskContext: 'Görev saat {time}',
};
//# sourceMappingURL=reminders.tr.js.map